import { BigNum } from '@velocity-exchange/sdk';
import React from 'react';
import { compareDriftProps } from 'src/utils/compareProps';
import { cj, cm } from 'src/utils/classNames';
import { ArrowRight } from '@velocity-exchange/icons';

export interface ValueChangeDisplayProps {
	previousValue: number | BigNum;
	afterValue: number | BigNum;
	leftSymbol?: string;
	rightSymbol?: string;
	icon?: React.ReactNode;
	previousValuePrint: string;
	afterValuePrint: string;
	reverseColours?: boolean;
	forceWhite?: boolean;
	overrideNoValueChange?: boolean;
	className?: string;
}

const ValueChangeDisplay = ({
	previousValue,
	afterValue,
	leftSymbol = '',
	rightSymbol = '',
	reverseColours = false,
	forceWhite = false,
	previousValuePrint,
	afterValuePrint,
	overrideNoValueChange,
	className,
	icon,
}: ValueChangeDisplayProps) => {
	const isEqual =
		typeof afterValue === 'number'
			? afterValue === previousValue
			: afterValue.eq(previousValue as BigNum);

	const isLessThan =
		typeof afterValue === 'number'
			? afterValue < (previousValue as number)
			: afterValue.lt(previousValue as BigNum);

	const arrowColor = forceWhite
		? 'text-text-default'
		: isLessThan
			? !reverseColours
				? 'text-text-negative-red-button'
				: 'text-text-positive-green-button'
			: !reverseColours
				? 'text-text-positive-green-button'
				: 'text-text-negative-red-button';

	return (
		<div
			className={cm(
				'flex flex-wrap items-center justify-end gap-x-1',
				className
			)}
		>
			<span className="whitespace-nowrap">
				{`${leftSymbol}${previousValuePrint}${rightSymbol}`}
			</span>
			{!isEqual && !overrideNoValueChange && (
				<div className={cj('flex items-center', arrowColor)}>
					<ArrowRight />
				</div>
			)}
			{!isEqual && !overrideNoValueChange && (
				<span className="whitespace-nowrap">{`${leftSymbol}${afterValuePrint}${rightSymbol}`}</span>
			)}
			{icon && <span className="ml-1">{icon}</span>}
		</div>
	);
};

export default React.memo(ValueChangeDisplay, compareDriftProps);
